<template>
  <div>
    <van-nav-bar
        left-arrow
        title="店铺订单"
        @click-left="$router.go(-1)"
        left-text="">
    </van-nav-bar>
    <div style="padding-top: 50px" class="wxMyOrders">
      <van-search
          v-model="searchValue"
          show-action
          label=""
          placeholder="请输入搜索关键词"
          @search="refreshData"
      >
        <template #action>
          <div @click="refreshData">搜索</div>
        </template>
      </van-search>
      <!--      <div class="balance_header">-->
      <!--      </div>-->
      <!--      <div class="balance_tips" style="  box-shadow: 0 2px 12px rgb(100 101 102 / 12%) !important;">-->
      <!--        <div style="">-->
      <!--          <van-row class="user-links" style="padding-top: 40px">-->
      <!--            <van-col span="12">-->
      <!--              <div style="font-size: 19pt">{{ dayTotalBalance }}</div>-->
      <!--              <div class="topCount">今日实际收入(元)</div>-->
      <!--            </van-col>-->
      <!--            <van-col span="12">-->
      <!--              <div style="font-size: 19pt">{{ totalAmount }}</div>-->
      <!--              <div class="topCount">累计实际收入(元)</div>-->
      <!--            </van-col>-->
      <!--          </van-row>-->
      <!--        </div>-->
      <!--      </div>-->
      <div style="margin-top: 3px">
        <van-tabs v-model="active" @click="onClickTab">
          <van-tab title="全部"></van-tab>
          <van-tab title="已服务"></van-tab>
          <van-tab title="待服务"></van-tab>
        </van-tabs>
      </div>
      <div style="margin-top: 10px">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div
              v-for="item in list"
              :key="item.id">
            <div class="kyzCard" @click="goInfo(item.ordersn)">
              <div>
                <div
                    class="van-doc-demo-block__title_k data"
                    @click="goInfo(item.ordersn)">
                  <van-row>
                    <van-col span="18">
                      <div style="text-align: left;">下单时间：{{ item.createTime }}</div>
                    </van-col>
                    <van-col span="6">
                      <div style="text-align: right;color:red">状态：{{ types(item.orderFlag) }}</div>
                    </van-col>
                  </van-row>
                </div>
                <div style="margin-top: 5px">
                  <van-row>
                    <van-col span="18">
                      <div style="color: black;font-size: 12pt;margin-left: 10px" class="line2">[{{
                          item.userName
                        }}] {{
                          item.prodName
                        }}
                      </div>
                    </van-col>
                    <van-col span="1">
                    </van-col>
                    <van-col span="5">
                      <div style="text-align: right;margin-right: 10px">
                        <div style="color: black;font-size: 12pt"> {{
                            item.typeFlag === 0 ? ('❤️ ' + item.amount) : ('¥ ' + item.amount)
                          }}
                        </div>
                        <div style="font-size: 10pt">[查看]</div>
                      </div>
                    </van-col>
                  </van-row>
                </div>
                <div>
                  <van-row v-if="item.sysRemark" style="margin-top: 5px">
                    <van-col span="24">
                      <div style="color: red;font-size: 12pt;margin-left: 10px" class="line2">
                        备注：{{ item.sysRemark }}
                      </div>
                    </van-col>
                  </van-row>
                  <van-divider/>
                </div>
                <!--                -->
                <!--                <van-card-->
                <!--                    @click="goInfo(item.ordersn)"-->
                <!--                >-->
                <!--                  <template #title>-->
                <!--                    <div class="line1">-->
                <!--                      [{{ item.userName }}]-->
                <!--                      {{ item.prodName }}-->
                <!--                    </div>-->
                <!--                  </template>-->
                <!--                  <template #price>-->
                <!--                    <div style="font-weight: normal;font-size: 10pt;text-align: left">-->
                <!--                      {{ item.typeFlag === 0 ? ('爱心:' + item.amount) : ('¥ ' + item.amount) }}-->
                <!--                    </div>-->
                <!--                  </template>-->
                <!--                  <template #num>-->
                <!--                    共:{{ item.prodCount }}件-->
                <!--                  </template>-->
                <!--&lt;!&ndash;                  <template #footer>&ndash;&gt;-->
                <!--&lt;!&ndash;                    <van-button size="small">查看</van-button>&ndash;&gt;-->
                <!--&lt;!&ndash;                  </template>&ndash;&gt;-->
                <!--                </van-card>-->
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import {
  NavBar, Divider, Search,
  Button, Field, Tab, Tabs,
  List, Card
} from 'vant'
import {postAction} from '@/api/manage'

export default {
  components: {
    [Button.name]: Button, [Divider.name]: Divider, [Search.name]: Search,
    [List.name]: List, [Tab.name]: Tab, [Tabs.name]: Tabs,
    [Field.name]: Field, [NavBar.name]: NavBar, [Card.name]: Card,
  },

  data() {
    return {
      searchValue: '',
      active: 0,
      list: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      balanceLast: 0,
      kyz: this,
      totalAmount: 0,
      dayTotalBalance: 0,
      orderFlag: -1,
    }
  },
  mounted() {
    this.getBalance()
  },
  methods: {
    onLoad() {
      this.loadData()
    },
    onClickTab(name) {
      if (name === 0) {
        this.orderFlag = -1
        this.refreshData()
      } else if (name === 1) {
        this.orderFlag = 40
        this.refreshData()
      } else {
        this.orderFlag = 20
        this.refreshData()
      }
    },
    refreshData() {
      this.finished = true
      var that = this;
      this.$nextTick(() => {
        that.loading = false
        that.finished = false
        that.pageNumber = 1
        that.list = []
      })
    },
    goInfo(ordersn) {
      this.$router.push({name: 'manager/myOrderInfo', query: {ordersn: ordersn}});
    },
    getBalance() {
      const that = this
      //发送 post 请求
      postAction('/web/api/manager/balanceAmount', {}).then(function (response) {
        console.log(response.result)
        that.totalAmount = response.result.totalBalance
        that.dayTotalBalance = response.result.dayTotalBalance
      }).finally(() => {
      })
    },
    types(tt) {
      if (tt == 0) {
        return '待付款'
      } else if (tt == 20) {
        return '待服务'
      } else if (tt == 40) {
        return '已服务'
      } else if (tt == 100) {
        return '已取消'
      }
    },
    loadData() {
      const that = this
      //发送 post 请求
      postAction('/web/api/manager/getMyOrderList', {
        'pageNo': that.pageNumber,
        searchValue: that.searchValue,
        orderFlag: that.orderFlag
      }).then(function (response) {
        console.log(response.result)
        // 异步更新数据
        for (let i = 0; i < 10; i++) {
          if (response.result.data.records[i]) {
            that.list.push(response.result.data.records[i])
          }
        }
        that.pageNumber = that.pageNumber + 1
        // 加载状态结束
        that.loading = false
        // 数据全部加载完成
        if (that.list.length >= response.result.data.total) {
          console.log(32423423423)
          that.finished = true
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.van-card__bottom {
  padding-bottom: 20px;
}

.van-card__desc {
  margin-top: 6px;
}

.van-card__title {
  font-size: 11pt;
}

.wxMyOrders .van-card__price {
  font-size: 13pt !important;
}

.wxMyOrders .van-card__price-integer {
  font-size: 13pt !important;
}

.van-nav-bar {
  position: fixed;
  width: 100%;
}

.balance_header {
  background: url("/img/paysuccess-bg.png") no-repeat;
  background-size: 100%;
  height: 110px;
}

.balance_header .balance_amount {
  text-align: center;
  padding-top: 10px;
  font-size: 22pt;
  color: white
}

.balance_header .balance_zhan {
  text-align: center;
  padding-top: 0px;
  font-size: 11pt;
  color: white
}

.balance_tips {
  background-color: white;
  margin: -80px 20px 0px 20px;
  height: 120px;
  border-radius: 15px;
  text-align: center;
  line-height: 20px;
}

.kyzCard {
  background-color: white;
  color: #454545;
  font-size: 10pt;
  margin-bottom: 5px;
}

.kyzCard .data {
  margin: 0px 20px;
}

.kyzCard .kyzCardAmount {
  color: red;
  font-size: 21px;
  padding-top: 6px
}

.topCount {
  font-size: 10pt;
  margin-top: 12px;
  color: gray;
}
</style>
